export const NO_ACCESS_ROLE = 'no-access';
export const APP_NAME = 'authService';
export const ADMIN_ROLE = 'admin';
export const ANY_ROLE = 'any';
export const ARRAY_FILTER_OPERATORS = Object.freeze({
  IsAnyOf: 'isAnyOf',
  IsNotEmpty: 'isNotEmpty',
  IsEmpty: 'isEmpty',
});
